import type { CSSObject } from '@emotion/react'
import { FontWeights, Typeface } from '@opallabs/gem'

export const styles = (fontWeight: FontWeights): CSSObject => ({
  fontFamily: Typeface.Default,
  fontWeight,
})
